import { ListItem } from "components/listItem/ListItem";
import { useQuery } from "hooks/useQuery"

export const Home = () => {
    const { navigate } = useQuery();
    
    return (
        <div className="home-container">
            <ListItem title="공지사항" onClick={() => navigate('/notice')} />
            <ListItem title="FAQ" onClick={() => navigate('/faq')} />
            <ListItem title="알림" onClick={() => navigate('/notification')} />
            <ListItem title="문의하기" onClick={() => navigate('/qna')} />
        </div>
    )
}